<template>
  <section :class="[ 'content-section', section.classes ]" :data-section-index="idx">
    <div :class="[ 'content', { 'fade-in': showContent } ]">
      <component
        v-for="(item, index) in section.items"
        :key="index"
        :is="item.type"
        :item="item"
        @action="onAction"
      ></component>
    </div>
  </section>
</template>
  
<script>
import NodeHeading from '../partials/NodeHeading.vue'
import NodeCalloutLines from '../partials/NodeCalloutLines.vue'
import NodeOverlay from '../partials/NodeOverlay.vue'
import NodeText from '../partials/NodeText.vue'
import NodeIconList from '../partials/NodeIconList.vue'

export default {
  name: 'ContentSection',
  components: {
    NodeHeading,
    NodeCalloutLines,
    NodeOverlay,
    NodeText,
    NodeIconList,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    idx: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showContent: false,

      eventHandlers: {},
    }
  },
  methods: {
    onAction(event) {
      if (event.type in this.eventHandlers) {
        return this.eventHandlers[event.type](event);
      }
      this.$emit('action', event);
    },
    activateState() {
      this.showContent = true;
      this.$emit('action', { type: 'activateButton' });
    },
  },
  mounted() {
    if (this.section.chapter !== null) {
      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: this.section.chapter,
          onEnded: () => this.activateState(),
        }
      });
    } else {
      this.activateState();
    }
    this.$emit('action', { type: 'updateHeader', data: this.section['header-color'] });
  },
}
</script>
